import { Link } from "react-router-dom";
import { Icon_RedirectToCase } from "../../../../BP2Components/Icons/icons";
import { useIntl } from "react-intl";
import "./LinkToCase.less";

export const LinkToCase = ({
   linkToCase,
   onClick,
}: {
   linkToCase: { pathname: string; search: string } | string;
   onClick?: () => void;
}) => {
   const intl = useIntl();

   return (
      <Link to={linkToCase} target="_self" className="link-to-case" onClick={onClick}>
         <span className="link-to-case__title">{intl.formatMessage({ id: "case.openCase" })}</span>
         <Icon_RedirectToCase />
      </Link>
   );
};
